module.exports = __webpack_public_path__ + "img/capacitor-green.82046d9e.png";